import { type ElementType, forwardRef } from 'react';

import { css, cx } from '@/styled-system/css';

import { dropdownHeadingStyles } from './styles/dropdown-heading.styles';
import type { DropdownHeadingPropsInterface } from './types/dropdown-heading.types';

/**
 * @since 10.0.0
 */

export const DropdownHeading = forwardRef<HTMLHeadingElement, DropdownHeadingPropsInterface>(
  (props: DropdownHeadingPropsInterface, forwardedRef) => {
    const { className, css: cssProp, level, ...rest } = props;
    const styles = css(dropdownHeadingStyles, cssProp);
    const Component: ElementType = `h${level}`;
    return (
      <Component
        ref={forwardedRef}
        data-c11n-component="Dropdown.Heading"
        data-c11n-version={__C11N_VERSION__}
        className={cx('c11n', styles, className)}
        {...rest}
      />
    );
  },
);

DropdownHeading.displayName = 'Dropdown.Heading';
